/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const Slider = require('../ui/slider');
const trackingUtils = require('../utils/tracking.utils');
const CLOSE_TO_LOCATION = Odigeo.UIElements.translations.dynpackProduct.filterTags['CLOSE_TO_LOCATION'];
const CLOSE_TO_CENTRE = Odigeo.UIElements.translations.dynpackProduct.filterTags['CLOSE_TO_CENTRE'];
const Dynpack = require('od-apps/app.dynpack');

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,
    slider: {},

    selectors: {
        sliderContainer: '.accommodationfilters_slider_container',
        selectedDistanceLabel: '.selected_distance',
        titleWithDestination: '.accommodation_filter_close_to_destination',
    },

    init: function() {
        this.options = this.widget.options;
        this.slider = new Slider(this.$cachedSelectors.sliderContainer, {
            range: {
                min: this.model.get('boundaryMinDistance'),
                max: this.model.get('boundaryMaxDistance'),
            },
            values: [this.model.get('selectedDistance')],
            unit: 'km',
            showRange: this.options.showSliderRange,
            showSelectedValueOnHandler: this.options.showSliderValue,
            styleClass: 'od-ui-spaced-slider',
        });

        this.listenTo(this.slider, 'slider:move', this.updateDistanceLabel);
        this.listenTo(this.slider, 'slider:change', this.userDistanceSelection);
        this.slider.$container.on('slider:change', trackClickEvent);
        this.listenTo(this.slider, 'slider:invalidValues', this.updateDistanceLabel);

        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanDistanceFilter, this));
    },

    userDistanceSelection: function(values) {
        var selectedDistance = Odigeo._.first(values);

        this.sendToFather({
            distanceFilterModel: [{selectedDistance: selectedDistance}],
        });

        if (Odigeo._.isNumber(selectedDistance) &&
            selectedDistance > -1) {
            trackingUtils.trackEvent('results_filters_hotels', 'situation_distance_' + selectedDistance);
        }
    },

    cleanDistanceFilter: function() {
        this.resetView(true);
        this.sendToFather({
            distanceFilterModel: [{selectedDistance: this.model.get('maxDistance')}],
        });
    },

    sendToFather: function(msg) {
        this.$el.trigger('filterHasChanged.accommodationfilter', msg);
    },

    updateDistanceLabel: function(values) {
        this.$cachedSelectors.selectedDistanceLabel.html(values[0] + ' ' + this.slider.opts.unit);
    },

    render: function() {
        this.slider.refresh({
            range: {
                min: this.model.get('boundaryMinDistance'),
                max: this.model.get('boundaryMaxDistance'),
            },
            values: [this.model.get('selectedDistance')],
        });

        this.resetView(this.model.get('isResetRequested'));
        this.updateDistanceLabel(this.slider.opts.values);

        return this;
    },

    reRender: function($page) {
        if (Dynpack.isAccommodationResults($page.attr('id'))) {
            this.render();
        }
    },

    resetView: function(isResetRequested) {
        if (isResetRequested) {
            this.stopListening(Odigeo)
                .listenTo(Odigeo, 'page:afterSwitch', this.reRender);
        }
    },

    renderTitleWithDestination: function(destination) {
        let stringTitle = destination ? Odigeo.Utils.replaceCmsKeyArgs(CLOSE_TO_LOCATION, destination) : CLOSE_TO_CENTRE;
        this.$el.find(this.selectors.titleWithDestination).html(stringTitle);
    },
});
